<div class="series-correction-output">
  <h4 class="title">List of corrections completed</h4>
  @if (isCompletedOutput(outputData)) {
    <div>
      <div class="row">
        <label style="width:400px;">SERIES ADJUSTED</label>
        <label style="width:400px;">NUMBER OF DATA POINTS UPDATED</label>
        <label style="width:400px;">CORRECTION FACTOR</label>
      </div>
      @for (series of outputData.corrected; track series) {
        <div class="row">
          <div style="width:400px;">{{seriesDict[series.series_id]?.attributes | nameOrDescription}}</div>
          <div style="width:400px;">{{series.update_count}}</div>
          <div style="width:400px;">{{series.correction_factor}}</div>
        </div>
      }
    </div>
  }
</div>
